import { render, staticRenderFns } from "./RelateInegiCode.vue?vue&type=template&id=3a90d7c5&"
import script from "./RelateInegiCode.vue?vue&type=script&lang=js&"
export * from "./RelateInegiCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports